<template>
  <div
    v-for="(group, key) in groups"
    :key="key"
  >
    <div
      class="sticky-position blurred-container no-border q-py-sm"
      style="top: 84px;"
    >
      <q-item-label
        class="text-subtitle2 cursor-pointer text-blue-8"
        @click="viewingGroupID = group.id"
      >
        {{ group.name }}
      </q-item-label>
      <q-item-label
        v-if="group.pivot && group.pivot.relationship"
        class="text-caption text-grey-7"
      >
        {{ group.pivot.relationship }}
      </q-item-label>
    </div>
    <div
      v-if="group.clients && group.clients.length > 0"
      class="q-mr-xs"
    >
      <ChildClientCard
        v-for="(client, cKey) in group.clients"
        :key="cKey"
        :client="client"
        @click="viewingClientID = client.id"
      />
    </div>
  </div>

  <ViewGroupDialog
    v-if="viewingGroupID"
    :id="viewingGroupID"
    @close="viewingGroupID = null"
    @updated="$emit('reload')"
    @deleted="onGroupDeleted"
  />
  <ViewClientDialog
    v-if="viewingClientID"
    :id="viewingClientID"
    :with-groups="false"
    @close="viewingClientID = null"
    @updated="$emit('reload')"
    @archived="$emit('reload')"
  />
</template>

<script>
import ChildClientCard from './ChildClientCard'
import { defineAsyncComponent } from 'vue'

export default {
  components: {
    ChildClientCard,
    ViewGroupDialog: defineAsyncComponent(() => import('../../../../groups/view/Dialog')),
    ViewClientDialog: defineAsyncComponent(() => import('../../../../partials/view/Dialog'))
  },
  props: {
    groups: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  emits: ['reload'],
  data () {
    return {
      viewingClientID: null,
      viewingGroupID: null
    }
  },
  methods: {
    onGroupDeleted (id) {
      const index = this.groups.map(item => item.id).indexOf(id)
      if (index > -1) {
        this.groups.splice(index, 1)
      }
    }
  }
}
</script>
